import React, { useId, useState } from "react";

function ChevronIcon({ open }) {
  return (
    <svg
      className={`admin-dash__collapsible-chevron${open ? " admin-dash__collapsible-chevron--open" : ""}`}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M10 7l5 5-5 5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/**
 * Accessible collapse for heavy dashboard sections.
 */
export function AdminCollapsiblePanel({
  title,
  subtitle,
  defaultOpen = true,
  badge,
  panelClassName = "",
  children,
}) {
  const [open, setOpen] = useState(defaultOpen);
  const btnId = useId();
  const regionId = `${btnId}-region`;

  return (
    <section
      className={`admin-dash__panel admin-dash__panel--collapsible${open ? " admin-dash__panel--collapsible-open" : ""} ${panelClassName}`.trim()}
    >
      <button
        type="button"
        id={btnId}
        className="admin-dash__collapsible-toggle"
        aria-expanded={open}
        aria-controls={regionId}
        onClick={() => setOpen((v) => !v)}
      >
        <span className="admin-dash__collapsible-toggle__leading" aria-hidden>
          <ChevronIcon open={open} />
        </span>
        <span className="admin-dash__collapsible-toggle__text">
          <span className="admin-dash__collapsible-toggle__title-row">
            <span className="admin-dash__collapsible-title">{title}</span>
            {badge != null && badge !== false ? (
              <span className="admin-dash__collapsible-badge-wrap">{badge}</span>
            ) : null}
          </span>
          {subtitle ? <span className="admin-dash__collapsible-sub">{subtitle}</span> : null}
        </span>
        <span className="admin-dash__collapsible-toggle__hint">
          {open ? "Hide" : "Show"}
        </span>
      </button>
      <div
        id={regionId}
        role="region"
        aria-labelledby={btnId}
        className="admin-dash__collapsible-region"
        data-open={open}
      >
        <div className="admin-dash__collapsible-inner">{children}</div>
      </div>
    </section>
  );
}

export default AdminCollapsiblePanel;
